import type { SentryModule } from '../types';

export const MODULE_HEADING: Record<SentryModule, string> = {
  landing: 'Landing',
  landing_cdb: 'Landing CDB',
  onboarding: 'Onboarding',
  payment_links: 'Payment Links',
  payment_forms: 'Payment Forms',
  payment_buttons: 'Payment Buttons',
  payments: 'Payments',
  settlements: 'Settlements',
  payouts: 'Payouts',
  developers: 'Developers',
  disputes: 'Disputes',
  reports: 'Reports',
  orders: 'Orders',
  refunds: 'Refunds',
  summary: 'Summary',
  settings: 'Settings',
  offers: 'Offers',
  one_click_checkout: 'One-Click Checkout',
  easy_split: 'Easy Split',
  softpos: 'SoftPOS',
  customers: 'Customers',
  customisation: 'Customisation',
  subscriptions: 'Subscriptions',
  risk_shield: 'Risk Shield',
  vba: 'VBA Accounts',
};

export const CONTAINER_HEADING: Record<string, string> = {
  PAYMENT_LINKS: 'Payment Links',
  PAYMENT_FORMS: 'Payment Forms',
  PAYMENT_BUTTONS: 'Payment Buttons',
  TRANSACTIONS: 'Payments',
  SETTLEMENTS: 'Settlements',
  DEVELOPERS: 'Developers',
  REPORTS: 'Reports',
  SUMMARY: 'Summary',
};
